import { AppLayout, State, useLayout, useTile } from "core";
import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import * as React from "react";
import FadeInImage from "../FadeInImage/FadeInImage";
import { usePreview } from "../Modals/PreviewContext";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { List, Page, Tile, getImageByOrientation } from "@blacknut/javascript-sdk/dist";
import { useSelector } from "react-redux";
import { ReactComponent as IcPassOverlay } from "../../assets/dist/ic_pass_overlay.svg";
import { useOrientation } from "src/utils/OrientationContext";

interface V2BannerTileProps {
  item: Tile;
  list: List;
  className?: string;
  inView: boolean;
  page?: Page;
}

const BannerTile = ({
  item,
  list,
  className,
  inView = true,
  page,
}: V2BannerTileProps) => {
  const { active: previewActive } = usePreview();
  const { config } = useSelector((state: State) => state.globalState);
  const blacknutPlus = !!config?.features?.blacknutplus;
  const isPassOnly =
    item.game?.addonOption?.inGamePass && !item.game?.addonOption?.isBonusGame;
  const isUnlocked =
    item.game?.addonOption?.userHasGamePass || item.game?.addonOption?.userHasBonusGame;

  const layout = useLayout();
  const { onClick } = useTile({
    item,
    previewMode: previewActive,
    pageUuid: page?.uuid,
  });
  const isMobile = layout === AppLayout.PHONE;
  const { orientation } = useOrientation();
  const imgBanner = getImageByOrientation(orientation, list.imgBackground ?? []);
  return (
    <Focusable
      className={clsx(styles.container, styles.focusable, className)}
      onClick={onClick}
      onPressEnter={onClick}
    >
      {inView && <FadeInImage image={imgBanner} className={styles.image} />}
      {blacknutPlus && isPassOnly && !isUnlocked && (
        <span
          className={clsx(styles.bonus, isMobile && styles.onMobileBonus)}
          data-testid="pass"
        >
          <IcPassOverlay />
        </span>
      )}
    </Focusable>
  );
};

export default BannerTile;
